import { getMfeVersion, setMfeVersion } from '../../settings';
import { error } from './error';
/**
 * Creates a logger instance with a default context.
 * @param {LoggerOptions} options - The logger options. Includes the default context.
 * @param {Context} options.context - The default context to use for the logger. Must include 'mfe' and 'team' properties.
 * @returns {CreateLogger} A logger instance with methods for logging. The instance includes:
 *   - error(name, errorToLog, context?): Logs an error with the given name, error object, and optional additional context
 */
export const createLogger = ({ context: defaultContext }) => {
    if (defaultContext?.version) {
        setMfeVersion(defaultContext.mfe, defaultContext.version);
    }
    const version = getMfeVersion(defaultContext.mfe);
    return {
        error: (name, errorToLog, context) => error(name, errorToLog, {
            ...defaultContext,
            ...context,
            version,
        }),
    };
};
